module.exports = __webpack_public_path__ + "static/media/1.b27989fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/works/crypto/images/1.png
// module id = 146
// module chunks = 0